import { StorageManager } from '../../../../common/storage-manager.class';
import { environment } from '../../../../../environments/environment';

export class FincasEnvironmentDefinition {
  public appName = environment.appName;

  public activateREA = environment.features.activateREA;

  public applicationType = environment.features.applicationType;

  public serverUrl = environment.serverUrl;

  public rol: string = StorageManager.getUser().rol;

  public hasClients = environment.features.hasClients;

  public userCanSeeClientes = this.hasClients &&
      (environment.features.userCanSeeClientes ? true : (this.rol === 'admin'));

  public clienteName = environment.features.clienteName;

  public fincaName = environment.features.fincaName;

  public hasPlantas = environment.features.hasPlantas;

  public activateSIEX = environment.features.activateSIEX;

  public showNumeroFincas = environment.features.showNumeroFincas;

  public fincasName = environment.features.fincasName;

  public sectorName = environment.features.sectorName;

  public showCargaPAC = environment.features.showCargaPAC;

  public showCuadernoDeCampo = environment.features.showCuadernoDeCampo;

  public cuadernoOnlyByYear = environment.features.cuadernoOnlyByYear;

  public showCuadernoPorSector = environment.features.showCuadernoPorSector;

  public showClientesCooperativa = environment.features.showClientesCooperativa;

  public showFincasRazonSocial = environment.features.showFincasRazonSocial;

  public showTipoExplotacion = environment.features.showTipoExplotacion;

  public showFincasCodigo = environment.features.showFincasCodigo;

  public showFincasGenGml = environment.features.showFincasGenGml;

  public showFincasCsv = environment.features.showFincasCSV;

  public canDuplicateFinca = environment.features.canDuplicateFinca;

  public fincasNifAutocomplete = environment.features.fincasNifAutocomplete;
    
  public fincasNifRequired = environment.features.fincasNifRequired;
    
  public showFincasProductos = environment.features.showFincasProductos;

  public user = StorageManager.getUser();

  public canAddFincas = environment.features.canAddFincas;

  public canEditFincas = environment.features.canEditFincas;

  public canDeleteFincas = environment.features.canDeleteFincas;
}// class;